export default __webpack_public_path__ + "static/media/Features_Recommendation_Image.63ed845f.png";